// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__14xjE","file":"styles_file__3i3JD"};